/* eslint-disable react/jsx-no-target-blank */
// import { Button } from "@material-ui/core";
import { motion } from "framer-motion";
import React from "react";
import { Col, Row } from "react-bootstrap";
import { scrollReveal } from "../../animation";
import { useScroll } from "./useScroll";
import Img from "react-cool-img";

// can add Research Paper thingy here.
const myPublications = [
  // {
  //   image: "https://blog.masaischool.com/content/images/size/w2000/2022/05/Aman-Anku.png",
  //   title: "My Journey",
  //   dLink:"Aman’s Never-Ending Dream Of Becoming A Coder Finally.........",
  //   demoLink: "https://blog.masaischool.com/amans-never-ending-dream-of-becoming-a-coder-finally-came-true-this-is-how/",
  // },
  // {
  //   image: "https://www.poynter.org/wp-content/uploads/2020/06/shutterstock_1211814685.png",
  //   title: "EMPLOYEE SPOT AWARD MAY 2021",
  //   dLink: "Got the Spot award for May 2021 at Nextory Pvt Lmt For my contribution of integrating and successfully deliver it in a time, A new module to our Spain website and parallelly working on the other bugs and tasks.",
  // },
  // {
  //   image: "https://www.poynter.org/wp-content/uploads/2020/06/shutterstock_1211814685.png",
  //   title: "EMPLOYEE SPOT AWARD NOVEMBER 2021",
  //   dLink: "Got The Spot Award for my contribution and dedication to the work and also taking more tasks and its responsibility, adding value to the discussion for my views ahead for the functionality to be discussed.I communicate across the team and other teams as well to get the dependencies discussed and get to completion",
  // }
  {
    image: "/images/SQL_publication2.png",
    title:
      "Detection of SQL Injection Attacks by giving apriori to Q-Learning Agents",
    dLink:
      "The SQL Injection vulnerability can either be unintentional by software developers or an intentional ploy employed by a hacker with malicious intent to exploit sensitive data. With the recent surge in information, there is an innate quest to safeguard this information from falling into the wrong hand leading to data theft, leak of personal data or loss of property. With relational databases like MySQL being the most popular, it allows users to extract any available information without any significant knowledge of databases. With vast information stored in databases warrants attacker’s attention, potentially risking critical confidential information. The premature detection of SQL Injection Attacks will be very helpful in preventing any malicious attempt by an attacker. In this research, we analyze the results of Reinforcement Learning algorithms like Q-Learning on a dataset consisting of potential SQL Injection queries. We intend to provide a Reinforcement Learning solution to minimise the potential threat posed by SQL Injection and give apriori to the model to learn to detect a SQL attack and prevent any unforeseen mishap more quickly and accurately.",
    descp: "",
    demoLink: "https://ieeexplore.ieee.org/document/10149965",
    websiteLink: "https://ieeexplore.ieee.org/document/10149965",
  },
  {
    image: "/images/SQL_publication.png",
    title:
      "A Detailed Evaluation of SQL Injection Attacks, Detection and Prevention",
    dLink:
      "An SQL Injection attack is a database focused attack for programmers that utilise data. It is accomplished by inserting malicious lines of code into the SQL query to alter and modify its meaning, allowing the attacker to gain access to the database or retrieve sensitive data. Many strategies for detecting and preventing such assaults have been developed and suggested. This study provides an in depth examination of 38 publications on approaches for detecting SQL Injection in web applications. This offers a foundation for designing and using efficient SQL Injection, detection and prevention techniques.",
    // descp: "22627279",
    demoLink: "https://doi.org/10.1109/ICAST55766.2022.10039662",
    websiteLink: "https://doi.org/10.1109/ICAST55766.2022.10039662",
  },
  {
    image: "/images/RIQ_publication.png",
    title: "Reverse Image Querying",
    dLink:
      "A Research Paper written on 'Reverse Image Quering using Cosine Similarity Model' published in a reputed international journal. We have implemented and improvised a rudimentary yet efficient solution by using the cosine similarity model to extract similar images for the given input image from the user.",
    // descp: "Paper # IJRASET44822",
    demoLink: "https://doi.org/10.22214/ijraset.2022.44822",
    websiteLink:
      "https://www.ijraset.com/ijraset-volume/volume10-issuevi-june2022#",
  },
  // {
  //   image: "/",
  //   title:
  //     "Comparative Study on Detection of SQL Injection Vulnerabilities using various Machine Learning Algorithms",
  //   dLink:
  //     "A detailed comparative study of detection of SQL Injection Vulnerabilities using various Machine Learning Algorithms.",
  //   descp: "Paper 034",
  //   demoLink: "/",
  //   websiteLink: "/",
  // },
];

const Publications = () => {
  const [element, controls] = useScroll();
  return (
    <div className="projects1" id="publications">
      <motion.div
        variants={window.innerWidth > 767 ? scrollReveal : null}
        ref={element}
        animate={controls}
        className="container pt-6 pb-6"
      >
        <div className="heading-section">
          <h1>
            <span className="chonburi-font green-text">Publi</span>cations
          </h1>
        </div>
        <div className="projects-cards">
          <Row className="justify-content-center">
            {myPublications.map((publication, index) => {
              return (
                <Col md={4} className="mb-5" key={index + 1}>
                  <div className="project-card">
                    <a href={publication.demoLink} target="_blank">
                      <div className="img-section">
                        <Img
                          placeholder="https://p4.wallpaperbetter.com/wallpaper/990/450/548/loading-wallpaper-preview.jpg"
                          src={publication.image}
                          error="/images/download.png"
                          alt="Publications"
                          className="fixImageDynamic"
                        />

                        <div className="imageCardEffect"></div>
                      </div>
                    </a>
                    <div className="project-info1">
                      <a href={publication.websiteLink} target="_blank">
                        <h5 className="color-white font-weight-bold">
                          {publication.title}
                        </h5>
                      </a>
                      <p className="color-white">{publication.dLink}</p>
                      <p className="color-white">{publication.descp}</p>
                      {publication.demoLink && (
                        <div className="d-flex justify-content-between mr-4">
                          <a
                            rel="noopener noreferrer"
                            href={publication.demoLink}
                            className="project-card-btn"
                            target="_blank"
                          >
                            View Paper ...
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>
              );
            })}
          </Row>
        </div>
      </motion.div>
    </div>
    // <>
    // </>
  );
};

export default Publications;
